import { useEffect, useState } from "react";
import { Button, Box, Typography } from "@mui/material";
import Flag from "react-world-flags";

interface ScoreResponse {
  palestine_score: number;
  israel_score: number;
}

export default function ClickerGame() {
  const [palestineScore, setPalestineScore] = useState<number>(1);
  const [israelScore, setIsraelScore] = useState<number>(1);
  const totalScore = palestineScore + israelScore;

  const palestinePercentage = (palestineScore / totalScore) * 100;
  const israelPercentage = (israelScore / totalScore) * 100;

  useEffect(() => {
    fetch("/api/score")
      .then((res) => res.json() as Promise<ScoreResponse>)
      .then((data) => {
        setPalestineScore(data.palestine_score);
        setIsraelScore(data.israel_score);
      })
      .catch((error) => {
        console.error("Failed to fetch scores:", error);
      });
  }, []);

  const handleClick = async (team: "palestine" | "israel") => {
    // const url = `${process.env.REACT_APP_BASE_URL || ""}/api/score`;
    const url = `/api/score`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ team }),
    });

    const data: ScoreResponse = await res.json();
    setPalestineScore(data.palestine_score);
    setIsraelScore(data.israel_score);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      height="100vh"
      bgcolor="#f0f0f0"
      p={2}
    >
      {/* Total Score */}
      <Typography variant="h4" sx={{ mb: 2 }}>
        Total Score: {totalScore}
      </Typography>

      {/* Buttons & Scores */}
      <Box
        display="flex"
        justifyContent="space-between"
        width="100%"
        maxWidth={400}
        mt={4}
      >
        {/* Team Blue */}
        <Box display="flex" flexDirection="column" alignItems="center">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#4CAF50" }}
            onClick={() => handleClick("palestine")}
          >
            Team Palestine
          </Button>
          <Typography variant="h6" sx={{ mt: 2 }}>
            {palestineScore}
          </Typography>
        </Box>

        {/* Team Green */}
        <Box display="flex" flexDirection="column" alignItems="center">
          <Button
            variant="contained"
            sx={{ backgroundColor: "#2196F3" }}
            onClick={() => handleClick("israel")}
          >
            Team Israel
          </Button>
          <Typography variant="h6" sx={{ mt: 2 }}>
            {israelScore}
          </Typography>
        </Box>
      </Box>

      {/* Dynamic Box */}
      <Box
        display="flex"
        width="100%"
        height={500}
        // border="0px solid #000"
        mt={2}
      >
        <Box width={`${palestinePercentage}%`} height="100%" overflow="hidden">
          <Flag
            code="PS"
            style={{ height: "100%", width: "100%", objectFit: "cover" }}
          />
        </Box>
        <Box width={`${israelPercentage}%`} height="100%" overflow="hidden">
          <Flag
            code="IL"
            style={{ height: "100%", width: "100%", objectFit: "cover" }}
          />
        </Box>
      </Box>
    </Box>
  );
}
